import { ThemesDataResolver } from '@b2b/common/resolvers';
import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { AccountProfileControllerModule } from './controllers/AccountProfileController';

export const AccountProfileView = angular
  .module('acme.view.application.account.profile', [
    uiRouter,
    'ui.bootstrap',
    AccountProfileControllerModule,
    'acme.common.directive.switcher',
  ])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.account.profile',
      url: '/profile?changePassword',
      views: {
        'subview-main': {
          controller: 'AccountProfileController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/account/profile/profile.tpl.html',
        },
      },
      data: {
        pageTitle: 'My Profile',
        roles: ['user', 'admin'],
      },
      resolve: {
        ThemesData: ThemesDataResolver(),
      },
    });
  }).name;
